import {
    baseUrl
} from '@/config/env';
import request from '@/router/axios';
import {
    parseParam
} from '@/util/util';

export const findOrderList = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-invoice-system/v2/order?` + params,
        method: 'GET'
    })
}
//删除订单
export const deleteOrder = (id) => {
    return request({
        url: `${baseUrl}/joins-invoice-system/v2/app-order/${id}`,
        method: 'DELETE'
    })
}
//查看订单详情
export const findOrderDetail = (id) => {
    return request({
        url: `${baseUrl}/joins-invoice-system/v2/app-order/${id}`,
        method: 'GET'
    })
}
//选择配送商
export const selectDelivery = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-invoice-system/v2/order/provider?` + params,
        method: 'PUT'
    })
}
export const findOrderListExcel = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-product/v1/shipment/shipmentExcel?` + params,
        method: 'GET'
    })
}
export const findProductGoodsList = () => {
    return request({
        url: `${baseUrl}/joins-product/v1/product/all`,
        method: 'GET'
    })
}
export const v2ProductSelect = () => {
    return request({
        url: `${baseUrl}/joins-product/v2/product/select`,
        method: 'GET'
    })
}

export const addOrder = (data) => {
    return request({
        url: `${baseUrl}/joins-product/v1/shipment/addOrder`,
        method: 'POST',
        data: data
    })
}
export const addOrder2 = (data) => {
    return request({
        url: `${baseUrl}/joins-product/v1/shipment/addOrder2`,
        method: 'POST',
        data: data
    })
}
export const findOrderById = (id) => {
    return request({
        url: `${baseUrl}/joins-product/v1/shipment/shipmentDetail/${id}`,
        method: 'GET'
    })
}
export const updateOrder = (data) => {
    return request({
        url: `${baseUrl}/joins-product/v1/shipment/updateOrder`,
        method: 'PUT',
        data: data
    })
}
export const send = (id) => {
    return request({
        url: `${baseUrl}/joins-product/v1/shipment/send/${id}`,
        method: 'GET'
    })
}

export const engineerGoodsSelect = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-invoice-system/v2/put/goods?`+params,
        method: 'GET'
    })
}
export const findProductGoodsById= (id) => {
    return request({
        url: `${baseUrl}/joins-invoice-system/v2/put/goods/${id}`,
        method: 'GET'
    })
}
export const addEngineerOrder = (data) => {
    return request({
        url: `${baseUrl}/joins-invoice-system/v2/delivery-order`,
        method: 'POST',
        data: data
    })
}
